// auth module
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const SET_CONNECT_USER = 'SET_CONNECT_USER'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const IS_LOGGED = 'IS_LOGGED'
export const SET_TOKEN_URL = 'SET_TOKEN_URL'
export const SET_INIT_SEARCH = 'SET_INIT_SEARCH'

export const LOGOUT = 'LOGOUT'

// board module
export const ADD_TO_SELECTION = 'ADD_TO_SELECTION'
export const REMOVE_FROM_SELECTION = 'REMOVE_FROM_SELECTION'
export const ETAT_MENU = 'ETAT_MENU'
export const LIST_ALL_BOARD = 'LIST_ALL_BOARD'
export const NEW_BOARD = 'NEW_BOARD'
export const UPDATE_BOARD = 'UPDATE_BOARD'
export const NEW_BOARD_POPUP_STATE = 'NEW_BOARD_POPUP_STATE'
export const EDIT_BOARD_DATA = 'EDIT_BOARD_DATA'
export const DELETE_BOARD = 'DELETE_BOARD'
export const LAUNCH_MEETING_MODERATEUR = 'LAUNCH_MEETING_MODERATEUR'
export const LAUNCH_MEETING_PARTICIPANT = 'LAUNCH_MEETING_PARTICIPANT'
export const EMPTY_MEETING = 'EMPTY_MEETING'
export const CLOSE_MEETING = 'CLOSE_MEETING'
export const BOARD_DATA_LOADED = 'BOARD_DATA_LOADED'
export const SOCKET_STATE = 'SOCKET_STATE'
export const NEW_POST = 'NEW_POST'
export const UPDATE_POST = 'UPDATE_POST'
export const LOAD_FOLDER = 'LOAD_FOLDER'
export const UPDATE_FOLDER = 'UPDATE_FOLDER'
export const DELETE_FOLDER = 'DELETE_FOLDER'
export const NEW_POST_POPUP_STATE = 'NEW_POST_POPUP_STATE'
export const NEW_POST_DEFINE_COORDS = 'NEW_POST_DEFINE_COORDS'
export const NEW_POST_DEFINE_COLOR = 'NEW_POST_DEFINE_COLOR'
export const CHANGE_POST_COLOR = 'CHANGE_POST_COLOR'
export const POST_ACTION_POPUP_STATE = 'POST_ACTION_POPUP_STATE'
export const UPDATE_POST_POPUP = 'UPDATE_POST_POPUP'
export const RECHERCHE_BOARD = 'RECHERCHE_BOARD'
export const LOAD_TEMPLATES = 'LOAD_TEMPLATES'
export const SET_BG_IMAGE = 'SET_BG_IMAGE'
export const CHANGE_CURRENT_SHEET = 'CHANGE_CURRENT_SHEET'
export const NEW_SHEET = 'NEW_SHEET'
export const REMOVE_SHEET = 'REMOVE_SHEET'
export const UPDATE_SHEET = 'UPDATE_SHEET'
export const UPDATE_SHEET_LIST = 'UPDATE_SHEET_LIST'
export const IS_LOADING = 'IS_LOADING'
export const URL_MODERATEUR = 'URL_MODERATEUR'
export const CHANGE_LINK_PARENT = 'CHANGE_LINK_PARENT'
export const CREATE_LINK = 'CREATE_LINK'
export const SHOW_PICTURE = 'SHOW_PICTURE'
export const SET_CONNECT_USER_ID = 'SET_CONNECT_USER_ID'
export const SET_CONNECT_USER_EMAIL = 'SET_CONNECT_USER_EMAIL'
export const SET_ID_ENTREPRISE = 'SET_ID_ENTREPRISE'
export const SET_ID_PLATEFORME = 'SET_ID_PLATEFORME'
export const SET_INSIDE_IFRAME = 'SET_INSIDE_IFRAME'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js